import { useState, useEffect } from 'react';
import {
  getCartVariants,
  getCount,
  getVariantQuantityLimits,
} from '@nexus/fff-cart';

function useCartData(
  cartDetails,
  products,
  variants,
  prevPurchasedVariantQuantities
) {
  const [cartData, setCartData] = useState({
    cartVariants: [],
    cartDetails: {},
    initialCredits: {},
    itemsCount: 0,
  });

  useEffect(() => {
    const { initialPurchaseCredit } = cartDetails;
    let cartVariants = getCartVariants(cartDetails, variants, products);
    const count = getCount(cartVariants);
    cartVariants = getVariantQuantityLimits(
      cartVariants,
      prevPurchasedVariantQuantities
    );
    setCartData({
      cartVariants,
      cartDetails,
      initialCredits: { initialPurchaseCredit },
      itemsCount: count,
    });
  }, [cartDetails]);
  return cartData;
}

export default useCartData;
